import { useState, useEffect } from 'react';
import ServiceClassificationService from '../MatrixSLA/components/serviceClassifications/service';
import { toast } from 'react-toastify';

export const useGetAllServiceClassifications = (id) => {
  const [allServiceClassification, setAllServiceClassification] = useState([]);
  const [loadingClassifications, setLoadingClassifications] = useState(false);

  const fetchServiceClassification = () => {
    setLoadingClassifications(true);
    if (id) {
      ServiceClassificationService.getAllServiceClassificationByMatrixSLAId(id)
        .then((res) => {
          const data = res.data.content;
          setAllServiceClassification(data);
          setLoadingClassifications(false);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              err.message ||
              'Erro ao buscar classificações de serviço'
          );
          setLoadingClassifications(false);
        });
    }
  };

  useEffect(fetchServiceClassification, [id]);

  return {
    allServiceClassification,
    fetchServiceClassification,
    loadingClassifications
  };
};
